import { Col } from 'antd';
import { Row } from 'components';
import React from 'react';
import { CountryPricingRules } from 'feature/countryTabs/pricing/countryPricingRules';
import { ClientTypePricingRules } from 'feature/countryTabs/pricing/clientTypePricingRules';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const CountryPricing = React.memo(() => {
  return (
    <Row gutter={[0, 44]}>
      <Col span={24}>
        <Col span={12}>
          <HasAccess role={PERMISSIONS.countries.pricing_rules.read}>
            <CountryPricingRules />
          </HasAccess>
        </Col>
      </Col>
      <Col span={12}>
        <HasAccess role={PERMISSIONS.countries.client_pricing_rules.read}>
          <ClientTypePricingRules />
        </HasAccess>
      </Col>
    </Row>
  );
});
